import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout'
import Home from '@/pages/home/index'
import Market from '@/pages/market/index'
import Item from '@/pages/market/item'
import Info from '@/pages/information/index'
import InfoItem from '@/pages/information/item'
import About from '@/pages/information/about'
import Cypher from '@/pages/cypher/index'
import Point from '@/pages/point/index'
import PointItem from '@/pages/point/item'
import Cart from '@/pages/pay/cart'
import Checkout from '@/pages/pay/checkout'
import Pay from '@/pages/pay/pay'
import Message from '@/pages/message/index'
import MessageItem from '@/pages/message/item'
import OrderDetail from '@/pages/order/detail'
import UserLayout from  '@/pages/user/userlayout'
import UserInfo from  '@/pages/user/info'
import Order from  '@/pages/user/order'
import Address from  '@/pages/user/address'
import Exchange from  '@/pages/user/exchange'
import PointChange from  '@/pages/user/point'
import Registrieren from  '@/pages/user/registrieren'
import NotFind from '@/components/error'
import UserAgreement from '@/pages/information/useragreement'
import PrivacyAgreement from '@/pages/information/privacyagreement'  
import ImpressumAgreement from '@/pages/information/impressumagreement'
import ShippingAgreement from '@/pages/information/shippingagreement'
import WithdrawalAgreement from '@/pages/information/withdrawalagreement'
import RegistrationAgreement from '@/pages/information/registrationagreement'




Vue.use(Router)
//*******以下为添加内容*******
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
//******以上为添加内容*********
export default new Router({
  routes: [{
      path: '/',
      name: "layout",
      component: Layout,
      children: [
        {
            path: '/',
            name: "home",
            component: Home,
            meta: {
              title: "Home"
            },
        },
        {
            path: '/market',
            name: "market",
            component: Market,
            meta: {
              title: "Market"
            },
        },
        {
            path: '/point',
            name: "point",
            component: Point,
            meta: {
              title: "points market"
            },
        },
        {
            path: '/point/item/:id?',
            name: "pointitem",
            component: PointItem,
            meta: {
              title: "points market"
            },
        },
        {
            path: '/cypher',
            name: "cypher",
            component: Cypher,
            meta: {
              title: "Cypher"
            },
        },
        {
            path: '/market/item/:id?',
            name: "marketitem",
            component: Item,
            meta: {
              title: "Market"
            },
        },
        {
            path: '/info',
            name: "info",
            component: Info,
            meta: {
              title: "Information"
            },
        },
        {
            path: '/info/item/:id?',
            name: "infoitem",
            component: InfoItem,
            meta: {
              title: "Information"
            },
        },
        {
            path: '/about',
            name: "about",
            component: About,
            meta: {
              title: "About US"
            },
        },
        {
            path: '/useragreement',
            name: "UserAgreement",
            component: UserAgreement,
            meta: {
              title: "Terms of Service"
            },
        },
        {
            path: '/privacyagreement',
            name: "PrivacyAgreement",
            component: PrivacyAgreement,
            meta: {
              title: "Privacy Policy"
            },
        },

        {
            path: '/impressumagreement',
            name: "ImpressumAgreement",
            component: ImpressumAgreement,
            meta: {
              title: "impressum"
            },
        },
        {
            path: '/shippingagreement',
            name: "ShippingAgreement",
            component: ShippingAgreement,
            meta: {
              title: "shipping & delivery"
            },
        },
        {
            path: '/withdrawalagreement',
            name: "WithdrawalAgreement",
            component: WithdrawalAgreement,
            meta: {
              title: "withdrawal policy"
            },
        },
        {
            path: '/registrationagreement',
            name: "RegistrationAgreement",
            component: RegistrationAgreement,
            meta: {
              title: "Registration Agreement"
            },
        },

        {
            path: '/cart',
            name: "cart",
            component: Cart,
            meta: {
              title: "Shopping cart"
            },
        },
        {
            path: '/checkout/:id?',
            name: "checkout",
            component: Checkout,
            meta: {
              title: "Checkout"
            },
        },
        {
            path: '/message',
            name: "message",
            component: Message,
            meta: {
              title: "Message"
            },
        },
        {
            path: '/message/item/:id?',
            name: "messageItem",
            component: MessageItem,
            meta: {
              title: "Message"
            },
        },
        {
            path: '/order/detail/:id?',
            name: "detail",
            component: OrderDetail,
            meta: {
              title: "Order"
            },
        },
        {
            path: '/pay/:id?',
            name: "pay",
            component: Pay,
            meta: {
              title: "Pay"
            },
        },
        {
            path: '/user/registrieren',
            name: "Registrieren",
            component: Registrieren,
            meta: {
              title: "Registrieren"
            },
        },
        {
            path: '/user/info',
            name: "userIndex",
            component: UserLayout,
            children: [
              {
                  path: '/user/info',
                  name: "userIndex",
                  component: UserInfo,
                  meta: {
                    title: "Info"
                  },
              },
              {
                  path: '/user/order',
                  name: "order",
                  component: Order,
                  meta: {
                    title: "Order"
                  },
              },
              {
                  path: '/user/address',
                  name: "Address",
                  component: Address,
                  meta: {
                    title: "Address"
                  },
              },
              {
                  path: '/user/exchange',
                  name: "Exchange",
                  component: Exchange,
                  meta: {
                    title: "Cypher"
                  },
              },
              {
                  path: '/user/point',
                  name: "PointChange",
                  component: PointChange,
                  meta: {
                    title: "Points"
                  },
              }
            ]
        },
      ]
    },
    {
      path: '*',
      name: "404",
      component: NotFind,
      meta: {
        title: "404"
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js